import { useCallback, useEffect, useState } from 'react';

import { toggleDrawer } from '@helpers';
import { useChatState } from '@core/chat';
import { ToggleDrawerType } from '@core/dashboard/interfaces';
import { useConference } from '@core/dashboard/components/DashboardContent/Dolby';
import { useClientSpecificChatDrawerWidth } from '@hooks/clientSpecificUtils';

import ChatDrawerView from './ChatDrawerView';

const ChatDrawer = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  const { screenMediaStreams } = useConference();
  const {
    open: isOpenChat,
    setOpen,
    initialLoading,
    streamClient,
    setChatDrawerWidth,
  } = useChatState();

  const { chatDrawerWidth } = useClientSpecificChatDrawerWidth();

  useEffect(() => {
    setChatDrawerWidth(chatDrawerWidth);
  }, [chatDrawerWidth]);

  const handleToggleDrawer: ToggleDrawerType = useCallback(
    (event) => {
      toggleDrawer(event, () => setOpen(!isOpenChat));
    },
    [isOpenChat, setOpen],
  );

  const autoClose = useCallback(() => {
    setOpen(false);
  }, [setOpen]);

  if (!streamClient) {
    return null;
  }

  return (
    <ChatDrawerView
      isOpenDrawer={isOpenChat}
      toggleDrawer={handleToggleDrawer}
      isLoading={initialLoading}
      hasScreenMediaStreams={!!screenMediaStreams?.length}
      isExpanded={isExpanded}
      setIsExpanded={setIsExpanded}
      autoClose={autoClose}
    />
  );
};

export default ChatDrawer;
